import { Component } from "react"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Redux */
import { connect } from "react-redux"

/* Helpers */
import { utils, withRouter } from "../../helpers"

/* Swal */
import Swal from "sweetalert2"

/* Components */
import { Input, Layout } from "../../components"

/* REST API */
import { edit, get } from "../../api/Currency"

/* Switch */
import Switch from "react-switch"

/* Translate */
import { t } from "../../translates/translate"



/* Page Currency Edit */
class CurrencyEdit extends Component {


    constructor() {
        super()

        this.state = {

            name: "",
            code: "",
            symbol: "",
            isAfter: false,
            waiting: false,
            status: "loading",
        }
    }


    componentDidMount = () => {
        this.load()
    }


    /* Load action */
    load = (reload = false) => {

        const { params } = this.props
        const { id } = params

        if (id) {

            if (reload) {
                this.setState({ status: "loading" })
            }

            get({ id }).then((response) => {
                if (response.status === 200) {
                    const data = response.data
                    this.setState({
                        name: utils.checkValue(data.name),
                        code: utils.checkValue(data.code),
                        symbol: utils.checkValue(data.symbol),
                        isAfter: (data.isAfter && parseInt(data.isAfter) > 0) ? true : false,
                        status: "ok",
                    })
                }
                else if (response.status === 401 || response.status === 403) {
                    this.setState({ status: "permission" })
                }
                else if (response.status === 498) {
                    this.setState({ status: "key" })
                }
                else {
                    this.setState({ status: "error" })
                }
            }).catch(() => {
                this.setState({ status: "network" })
            })
        }
        else {
            this.setState({ status: "error" })
        }

    }


    /* Save action */
    save = () => {

        const { name, code, symbol, isAfter } = this.state
        const { params, navigate } = this.props
        const { id } = params

        if (!id) {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
            return
        }

        if (name === "") {
            this._name.error(t("currency.error.emptyName"))
            return
        }

        if (code === "") {
            this._code.error(t("currency.error.emptyCode"))
            return
        }

        if (code.length !== 3) {
            this._code.error(t("currency.error.codeLength"))
            return
        }

        if (symbol === "") {
            this._symbol.error(t("currency.error.emptySymbol"))
            return
        }

        this.setState({ waiting: true })

        edit({ id, name, code, symbol, isAfter: isAfter ? "yes" : "no" }).then((response) => {
            if (response.status === 200) {
                Swal.fire(utils.notification(t("currency.savedSuccess"), "success")).then(() => {
                    navigate(-1)
                })
            }
            else if (response.status === 401 || response.status === 403) {
                Swal.fire(utils.notification(t("swal.noAccess"), "error"))
            }
            else if (response.status === 498) {
                Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
            }
            else {
                Swal.fire(utils.notification(t("swal.generic"), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
        }).finally(() => {
            this.setState({ waiting: false })
        })

    }

    /* Draw button */
    _button = () => {

        const { waiting } = this.state

        if (waiting) {
            return <div className="button"><LoadingOutlined /></div>
        }

        return <div onClick={() => this.save()} className="button">{t("common.save")}</div>
    }

    render = () => {

        const { status, name, code, symbol, isAfter } = this.state

        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} />
        }

        return (
            <div className="page">

                <div className="page-header">
                    <h1>{t("currency.editTitle")}</h1>
                </div>

                <div className="page-form">
                    <div className="form">
                        <div className="form-box">
                            <Input ref={(ref) => this._name = ref} label={t("currency.name")} value={name} onChange={(event) => this.setState({ name: event.target.value })} />
                            <Input ref={(ref) => this._code = ref} label={t("currency.code")} value={code} onChange={(event) => this.setState({ code: event.target.value })} />
                            <Input ref={(ref) => this._symbol = ref} label={t("currency.symbol")} value={symbol} onChange={(event) => this.setState({ symbol: event.target.value })} />

                            <div className="form-switch">
                                <span>{t("currency.symbolBefore")}</span>
                                <Switch uncheckedIcon={false} checkedIcon={false} onColor="#8bc34a" onChange={(value) => this.setState({ isAfter: value })} checked={isAfter} />
                            </div>
                        </div>
                    </div>

                    <div className="form-bottom">
                        {this._button()}
                    </div>

                </div>

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(withRouter(CurrencyEdit))
